import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6f25cfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "license-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "license-container-body" }
const _hoisted_5 = { class: "lm-row" }
const _hoisted_6 = { class: "lm-column" }
const _hoisted_7 = { class: "license-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "First Name", -1))
const _hoisted_9 = { class: "lm-column" }
const _hoisted_10 = { class: "license-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Last Name", -1))
const _hoisted_12 = { class: "lm-column" }
const _hoisted_13 = { class: "license-info" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "To", -1))
const _hoisted_15 = { class: "lm-column" }
const _hoisted_16 = { class: "license-info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Mail Template", -1))
const _hoisted_18 = { class: "lm-column" }
const _hoisted_19 = { class: "license-info" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Email Subject", -1))
const _hoisted_21 = { class: "update-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.modalHeader), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              type: "text",
              disabled: "",
              placeholder: "First Name",
              class: "form-control",
              modelValue: _ctx.firstName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputText, {
              type: "text",
              disabled: "",
              placeholder: "Last Name",
              class: "form-control",
              modelValue: _ctx.lastName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_InputText, {
            type: "text",
            disabled: "",
            placeholder: "To",
            class: "form-control",
            modelValue: _ctx.to,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.to) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_Dropdown, {
            class: "form-control",
            options: _ctx.mailTemplates,
            modelValue: _ctx.mailTemplate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mailTemplate) = $event))
          }, null, 8, ["options", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_InputText, {
            type: "text",
            placeholder: "Subject",
            class: "form-control",
            modelValue: _ctx.subject,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.subject) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          label: "Send",
          class: "p-button-secondary p-button",
          disabled: !_ctx.isFormValid,
          onClick: _ctx.submitForm
        }, null, 8, ["disabled", "onClick"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _ctx.cancelForm,
          label: "Cancel",
          class: "p-button-secondary p-button-outlined"
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}